import React from "react";
import { cancelOptions } from "../cancelOptions";

const MENU_STYLE = {
  position: "absolute",
  willChange: "transform",
  top: 0,
  left: 0,
  transform: "translate3d(0px, -82px, 0px)",
};

export default function CancelOrderMenu({ order, onCancel }) {
  return (
    <>
      <button
        type="button"
        className="btn btn-primary dropdown-toggle btn-xs "
        data-toggle="dropdown"
        aria-expanded="false"
      >
        Cancel
      </button>
      <div className="dropdown-menu" x-placement="top-start" style={MENU_STYLE}>
        {cancelOptions(order).map((option) => (
          <button key={option.type} type="button" className="dropdown-item" onClick={() => onCancel(option.type)}>
            {option.label}
          </button>
        ))}
      </div>
    </>
  );
}
